import _ from 'lodash';
import parse from 'html-react-parser';

/**
 * Template format string e.g "Replace {0} with and this {1}"
 * @param template
 * @param args format arguments to
 * @returns {string}
 */
export const format = (template, ...args) => {
  if (!template) {
    return '';
  }

  return parse(template.replace(/{\d+}/g, matchedStr => {
    const variableIndex = matchedStr.substr(1, matchedStr.length - 2);
    return args[variableIndex];
  }));
};

export const sortLocale = (list, iteratee = _.identity, locales = undefined, options = { sensitivity: 'base' }) => {
  const argTransform = _.iteratee(iteratee);
  return list?.sort((a, b) => {
    return argTransform(a)?.localeCompare(argTransform(b), locales, options);
  });
};

function levenshteinDistance(str1, str2) {
  const m = str1.length;
  const n = str2.length;

  const dp = Array.from({ length: m + 1 }, () => Array(n + 1).fill(0));

  for (let i = 0; i <= m; i++) {
    for (let j = 0; j <= n; j++) {
      if (i === 0) {
        dp[i][j] = j;
      } else if (j === 0) {
        dp[i][j] = i;
      } else {
        dp[i][j] = Math.min(
          dp[i - 1][j - 1] + (str1[i - 1] === str2[j - 1] ? 0 : 1),
          dp[i - 1][j] + 1,
          dp[i][j - 1] + 1
        );
      }
    }
  }

  return dp[m][n];
}

export const sortStringsByLevenshtein = (baseString, strings) => {
  return strings.sort((a, b) => {
    const distanceA = levenshteinDistance(baseString, a);
    const distanceB = levenshteinDistance(baseString, b);

    return distanceA - distanceB;
  });
};
